@let effectiveDate = ngControl.valueChanges | async | date: 'MM/dd/yyyy';

@if (!editMode()) {
  <div auxSkeletonLoader [loading]="loading()" class="flex h-full items-center">
    <ng-template #effectiveDateTooltip>
      <p class="min-w-52">
        {{ effectiveDateTooltipText }}
      </p>
    </ng-template>
    @if (!effectiveDate) {
      <aux-icon
        name="AlertTriangle"
        auxTooltip
        [template]="effectiveDateTooltip"
        class="mr-2 text-aux-error"
      />
    }
    <p>
      Effective Date:
      {{ effectiveDate || 'N/A' }}
    </p>
  </div>
} @else {
  <div [auxTooltip]="!isEffectiveDateEditable() ? startingSiteBudgetVersionEffectiveDateText : ''">
    <aux-input
      #effectiveDateInput
      auxSkeletonLoader
      [loading]="loading()"
      [formControl]="ngControl.control"
      [validators]="validateEffectiveDates()"
      [type]="'date'"
      label="Effective Date"
      class="min-w-52"
    />
  </div>
}
